import { useState } from 'react'
import reactLogo from './assets/react.svg'
import viteLogo from '/vite.svg'
import './App.css'
import Hompage from "./pages/Hompage.jsx"; // corrected typo
import Dashboard from "./pages/Dashboard.jsx"; 
import Signup from "./pages/Signup"; 
import Login from "./pages/Login"; 
import AdminDashBoard from "./pages/AdminDashBoard"; 
import DepositPage from "./pages/DepositPage"; 
import DepositAccount from "./pages/DepositAccount"; 
import {useNavigate, Route, Routes} from "react-router-dom"; 
import {NextUIProvider} from '@nextui-org/react'
import WithdrawPage from "./pages/WithdrawPage"; 
import ForgotPasswordPage from "./pages/ForgotPasswordPage"; 
import {AuthProvider} from "./AuthContext"; 
import ProtectedRoute from "./ProtectedRoute"; 
import KYCVerification from "./components/KYCVerification"; 
import BrevoConversation from "./components/BrevoConversation"; 
import ChooseInvestmentPlan from './pages/ChooseInvestmentPlan.jsx';
import AboutPage from "./pages/AboutPage"; 

function App() { 
  const navigate = useNavigate(); 
  return (
    <>
      <NextUIProvider> {/* removed navigate prop */}
        <AuthProvider>
			 <BrevoConversation />
          <Routes>
            <Route path="/" element={<Hompage />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path = "/about" element = {<AboutPage />} />
		<Route path = "/forgot-password" element = {<ForgotPasswordPage />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/deposit" element={<DepositPage />} />
              <Route path="/withdraw" element={<WithdrawPage />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path = "/chooseplan" element = {<ChooseInvestmentPlan/>} />
		<Route path="/admin" element={<AdminDashBoard />} />
            </Route>
            <Route path="/kyc-verification" element={<KYCVerification />} />
          </Routes>

        </AuthProvider>
      </NextUIProvider>
    </>
  );
}
export default App;

